import types from '../mutation-types';
import DealsAPI from '../../api/deals';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    hasFetchError: false,
  },
};

export const getters = {
  getDealsByContactId: _state => contactId => _state.records[contactId] || [],
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { contactId }) {
    commit(types.SET_CONTACT_DEALS_UI_FLAG, {
      isFetching: true,
      hasFetchError: false,
    });
    try {
      const {
        data: { payload },
      } = await DealsAPI.getByContact(contactId);
      commit(types.SET_CONTACT_DEALS, { contactId, data: payload });
    } catch (error) {
      commit(types.SET_CONTACT_DEALS_UI_FLAG, { hasFetchError: true });
    } finally {
      commit(types.SET_CONTACT_DEALS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_DEALS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONTACT_DEALS]($state, { contactId, data }) {
    $state.records = {
      ...$state.records,
      [contactId]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
